import React from 'react';
import { classes } from './styles.st.css';

/**
 * Secondary Payment Options Wrapper
 */
export const SecondaryPoWrapper = (props) => {
  return <div className={classes.restSources}>{props.children}</div>;
};
